module.exports = __webpack_public_path__ + "img/36_66.4cd91d9e.png";